import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PolicyLawsService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  getAllPolicyLaws(langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}policy-laws`);
    }

    return this.http.get(`${this.apiUrl}policy-laws?lang=${langCode}`);
  }

  getPolicyLawById(id: number, langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}policy-laws/${id}`);
    }

    return this.http.get(`${this.apiUrl}policy-laws/${id}?lang=${langCode}`);
  }

  create(request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return this.http.post(`${this.apiUrl}policy-laws`, formData);
  }

  update(id: number, request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return this.http.put(`${this.apiUrl}policy-laws/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}policy-laws/${id}`);
  }
}
